export default {"src":"/_next/static/media/logo-cloud.b20f2ffa.svg","height":40,"width":84,"blurWidth":0,"blurHeight":0};